import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';

export const cardStyles: SxProps<Theme> = {
	borderRadius: '16px',
	width: '100%',
	p: '16px 24px',
	maxWidth: '350px',
	height: 'fit-content',
	position: 'relative',
};

export const backgroundStyles: SxProps<Theme> = {
	borderRadius: '16px',
	overflow: 'hidden',
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
};

export const iconButtonStyles: SxProps<Theme> = {
	backgroundColor: Colors.black_a35,
	p: '11px',

	'& >svg': {
		color: Colors.white,
		width: '18px',
		height: '18px',
	}
};

export const eventNameStyles: SxProps<Theme> = {
	fontFamily: 'Montserrat, sans-serif',
	fontWeight: 700,
	fontSize: '18px',
	lineHeight: '100%',
	color: Colors.white,
	textDecorationThickness: '1px',
};

export const hostStyles: SxProps<Theme> = {
	display: 'flex',
	color: Colors.white,
	textDecoration: 'unset',
	alignItems: 'center',

	'& .MuiTypography-root': {
		fontWeight: 500,
		fontSize: '14px',
		lineHeight: '100%',
		marginRight: '4px',
		marginLeft: '8px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
	},

	'& >svg': {
		color: Colors.white,
		width: '14px',
		height: '14px',
	}
};

export const eventInfoItemStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	columnGap: '10px',

	'& > svg': {
		color: Colors.white,
		width: '24px',
		height: '24px',
	},

	'& > .MuiTypography-root': {
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: '100%',
		color: Colors.white,
	}
};

export const qrCodeWrapperStyles: SxProps<Theme> = {
	p: '7px',
	rowGap: '6px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	backgroundColor: Colors.white_a10,
	backdropFilter: `blur(44.9px)`,
	borderRadius: '12px',
};

export const qrCodeLabelStyles: SxProps<Theme> = {
	fontFamily: 'Montserrat, sans-serif',
	fontWeight: 600,
	fontSize: '15px',
	lineHeight: '100%',
	color: Colors.white_a80,
};

export const footerIconButtonStyles: SxProps<Theme> = {
	backgroundColor: Colors.black_a35,
	p: '10px 12px',

	'& >svg': {
		color: Colors.white,
		width: '16px',
		height: '16px',
	}
};

export const footerButtonStyles: SxProps<Theme> = {
	backgroundColor: Colors.black_a35,
	flex: 1,
	columnGap: '4px',
	whiteSpace: 'nowrap',

	'& >svg': {
		width: '16px',
		height: '16px',
	},

	'&:hover, &.Mui-focusVisible, &:active': {
		backgroundColor: Colors.white_a5
	},
};
